import React, { useContext } from 'react'
import axios from 'axios'
import AuthContext from '../../context/auth/authContext'
import { Route, Redirect } from 'react-router-dom'

/*
 * PrivateRoute protects views that are only able to be accessed
 * when authenticated - else redirect to login
 * First checks for 401 error (ie token error) from every server
 * response and logs user out if so.
 */
const PrivateRoute = ({ component: Component, ...rest }) => {
  const authContext = useContext(AuthContext)
  const { isAuthenticated, loading } = authContext

    // Add a response interceptor
    axios.interceptors.response.use(function (response) {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data if desired
      // console.log('Checked response...')
      return response;
    }, function (error) {
      // Any status codes that falls outside the range of 2xx cause this function to trigger
      // Do something with response error
      // Let's just do something when it is a 401 error, ie token error
      if(error.response.status === 401) {
        authContext.logout()
      }
      return Promise.reject(error)
    })

  return (
    <Route { ...rest } render={props => !isAuthenticated && !loading ? (
      <Redirect to='/login'/>
    ) : (
      <Component { ...props}/>
    )}/>
  )
}

export default PrivateRoute